import { computed, defineComponent } from 'vue';
export default defineComponent({
    props: {
        hover: {
            type: Boolean,
            required: false,
        },
    },
    setup(props) {
        const hoverStatus = computed(() => ({
            hovered: props.hover,
            white: !props.hover,
        }));
        return { hoverStatus };
    },
});
